import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderUpload"><Path d="M2 3H10.4014L12.4014 6H22V20H12.75V14.8107L14.5 16.5607L15.5607 15.5L12 11.9393L8.43934 15.5L9.5 16.5607L11.25 14.8107V20H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderUpload;
